export const infinityValidator = {
    message() {
        return `The value you have provided is larger than the maximum allowed numeric value: ${Number.MAX_VALUE}`;
    },
    validate(value: any) {
        return Number(value) <= Number.MAX_VALUE
    },
};
